import * as React from "react"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import Modal from "@mui/material/Modal"
import { Divider } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import { useDispatch } from "react-redux"
import { getTokenLocal } from "../../../../helper/utils"
import { setLoading } from "../../../redux/slices/appSlice"
import MetricAPI from "../../../../api/metric"
import { toast } from "react-toastify"
import {
  setOpportunitySelectedStatus,
  setOpportunityStatus,
} from "../../../redux/slices/metricSlice"
import { useSelector } from "react-redux"
import {
  setGroupProfileDetailChanged,
  setGroupProfileDetailsIsAssignedChanged,
  setIsAssignedBucketDetails,
  setSelectAllDisableCheck,
  setSelectedBucketDetails,
} from "../../../redux/slices/groupProfileSlice"
import GroupProfileAPI from "../../../../api/groupProfile"
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  height: 220,
  bgcolor: "background.paper",
  // border: '2px solid #000',
  borderRadius: "8px",
  boxShadow: 24,
  //p: 4,
}

type Props = {}
const metricAPI = new MetricAPI()
const groupProfileAPI = new GroupProfileAPI()
const MetricDetailsSelectAllConformation = ({
  openedSelectAll,
  handleSelectAllConfimClose,
}: any) => {
  const dispatch = useDispatch()
  const token: any = getTokenLocal()
  const selectedGroupSk = useSelector((state: any) => {
    return state.groupProfile.selectedGroupSk
  })

  const selectedBucketDetails = useSelector((state: any) => {
    return state.groupProfile.selectedBucketDetails
  })

  const groupProfileDetails = useSelector((state: any) => {
    return state.groupProfile.groupProfileDetails
  })

  const selectAllDisableCheck = useSelector((state: any) => {
    return state.groupProfile.selectAllDisableCheck
  })
  let selectData: any = {}
  let metrics: any = []
  let updatedmetrics: any = []

  const SelectAllHandler = async () => {
    selectedBucketDetails?.metrics?.forEach((ele: any) => {
      if (ele.isAssigned === false) {
        metrics.push({
          metric_bucket_id: selectedBucketDetails?.metric_bucket_id,
          metric_id: ele?.metric_id,
          isAssigned: true,
        })
      }
    })

    selectData["groups"] = [selectedGroupSk]
    selectData["metrics"] = metrics

    selectedBucketDetails?.metrics?.forEach((ele: any) => {
      updatedmetrics.push({
        ...ele,
        isAssigned: true,
      })
    })

    let updatedData = {
      ...selectedBucketDetails,
      metrics: updatedmetrics,
    }

    if (token) {
      const result = await groupProfileAPI.postMetricAssigned(token, selectData)

      if (result?.data?.status_code != 200) {
        //  console.log("result", result)
        toast.error(result?.data?.display_message)
      } else {
        toast.success(result?.data?.display_message)
        dispatch(setSelectAllDisableCheck(true))
        dispatch(setSelectedBucketDetails(updatedData))
        dispatch(
          setGroupProfileDetailChanged({
            index:
              groupProfileDetails.indexOf(selectedBucketDetails) === -1
                ? 0
                : groupProfileDetails.indexOf(selectedBucketDetails),
            checkValue: updatedData,
          }),
        )
        //console.log("selectedBucketDetails", selectedBucketDetails)
      }

      dispatch(setLoading(false))

      return result?.data?.status_code
    } else {
      toast.error(
        "There has been some localStorage Error, Please Logout and Login Again.",
      )
      dispatch(setLoading(false))
    }
  }
  return (
    <div>
      {/* <Button onClick={handleOpen}>Open modal</Button> */}
      <Modal
        open={openedSelectAll}
        onClose={handleSelectAllConfimClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box sx={{ width: "100%", height: "140px" }}>
            <Box
              sx={{
                width: "100%",
                height: "40px",
                display: "flex",
                flexDirection: "row-reverse",
                alignItems: "center",
              }}
            >
              <CloseIcon
                sx={{
                  marginRight: "10px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  handleSelectAllConfimClose()
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "96px",
              }}
            >
              <Typography
                id="modal-modal-title"
                fontSize={"18px"}
                fontWeight={500}
              >
                Are you sure to Assign all metrics
                {/* {`  Are you sure to ${
                  checkedData.isAssigned ? `Assign` : "Remove"
                } selected metric?`} */}
              </Typography>
            </Box>
            <Divider />
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                height: "80px",
                //padding: "10px 0 0 0",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Box
                  onClick={() => {
                    handleSelectAllConfimClose()
                  }}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "138px",
                    height: "40px",
                    borderRadius: "4px",
                    outline: "1px solid #4A79E7",
                    cursor: "pointer",
                  }}
                >
                  <Typography color={"#4A79E7"}>Cancel</Typography>
                </Box>
                <Box
                  onClick={() => {
                    SelectAllHandler()
                    handleSelectAllConfimClose()
                  }}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "138px",
                    height: "40px",
                    borderRadius: "4px",
                    marginLeft: "38px",
                    backgroundColor: "#4A79E7",
                    cursor: "pointer",
                  }}
                >
                  <Typography color={"#ffffff"}>Yes</Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </div>
  )
}

export default MetricDetailsSelectAllConformation
